import axios from 'axios';
import API from '../config/API';

export const reviewService = {
    submitReview,
    submitBothReviews,
    getBookingReviewStatus,
    getHairdresserReviews,
    getSalonReviews,
    getUserReviews
};

/**
 * Get authorization headers for API requests
 */
function getAuthHeaders() {
    const accessToken = localStorage.getItem('accessToken');
    return {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
}

/**
 * Submit a single review (hairdresser or salon)
 */
function submitReview(params) {
    const headers = getAuthHeaders();
    return axios.post(API.REVIEW_SUBMIT, params, { headers })
        .then(response => response.data)
        .catch(error => {
            console.error('Error submitting review:', error);
            throw error;
        });
}

/**
 * Submit both hairdresser and salon reviews at once
 */
function submitBothReviews(params) {
    const headers = getAuthHeaders();
    return axios.post(API.REVIEW_SUBMIT_BOTH, params, { headers })
        .then(response => response.data)
        .catch(error => {
            console.error('Error submitting reviews:', error);
            throw error;
        });
}

/**
 * Get review status for a booking
 */
function getBookingReviewStatus(bookingId) {
    const headers = getAuthHeaders();
    return axios.get(API.REVIEW_BOOKING_STATUS, { 
        params: { bookingId },
        headers 
    })
        .then(response => response.data)
        .catch(error => {
            console.error('Error getting booking review status:', error);
            throw error;
        });
}

/**
 * Get reviews for a hairdresser
 */
function getHairdresserReviews(hairdresserId, skip = 0, limit = 20) {
    const headers = getAuthHeaders();
    return axios.get(API.REVIEW_HAIRDRESSER, { 
        params: { hairdresserId, skip, limit },
        headers 
    })
        .then(response => response.data)
        .catch(error => {
            console.error('Error getting hairdresser reviews:', error);
            throw error;
        });
}

/**
 * Get reviews for a salon
 */
function getSalonReviews(salonId, skip = 0, limit = 20) {
    const headers = getAuthHeaders();
    return axios.get(API.REVIEW_SALON, { 
        params: { salonId, skip, limit },
        headers 
    })
        .then(response => response.data)
        .catch(error => {
            console.error('Error getting salon reviews:', error);
            throw error;
        });
}

/**
 * Get user's own reviews
 */
function getUserReviews(skip = 0, limit = 20) {
    const headers = getAuthHeaders();
    return axios.get(API.REVIEW_MY_REVIEWS, { 
        params: { skip, limit },
        headers 
    })
        .then(response => response.data)
        .catch(error => {
            console.error('Error getting user reviews:', error);
            throw error;
        });
}
